import React, { useContext } from 'react'
import Slider from 'react-slick'
import { useNavigate } from 'react-router-dom'
import { trackEvent } from 'analytics/trackFunctions'
// import { MeContext } from 'contexts/me'
import { settings } from 'constants/settingsCarousel'

// maybe used in next iteration
// import {
//   hasActiveMembership,
//   hasSuspendedMembership,
// } from 'utils'

import { internalScreens } from 'constants/personalize'

const BannerCarrousel = ({ banners }) => {
  const navigate = useNavigate()

  // maybe used in next iteration
  // const { me } = useContext(MeContext)

  // maybe used in next iteration
  // const membershipIsActiveOrSuspended =
  //   hasActiveMembership(me?.subscriber_products) ||
  //   hasSuspendedMembership(me?.subscriber_products)

  return (
    <div className='pb-7'>
      <Slider {...settings}>
        {banners.map((banner) => (
          <button
            onClick={() => {
              if (banner.external_url !== 'no') {
                window.open(banner.external_url, '_blank').focus()
              } else {
                navigate(internalScreens[banner.internal_screen_id])
              }
            }}
            key={banner.id}
          >
            <img src={banner.image_url} alt='' />
            <span className='sr-only'>Banner promocional</span>
          </button>
        ))}
      </Slider>
    </div>
  )
}

export default BannerCarrousel
